import React from 'react';
import { Camera, X } from 'lucide-react';
import { fileToResizedDataURL } from '../lib/images';
import AvatarCrop from './AvatarCrop';

export function MultiImagePicker({ photos, setPhotos, max = 4, label = 'Gallery photos', hint, toast, testidPrefix = 'gallery', crop = false }) {
  const [busy, setBusy] = React.useState(false);
  const [cropQueue, setCropQueue] = React.useState([]);
  const addFiles = async (files) => {
    const arr = Array.from(files || []).slice(0, Math.max(0, max - (photos || []).length));
    if (!arr.length) return;
    setBusy(true);
    try {
      const urls = (await Promise.all(arr.map(f => fileToResizedDataURL(f, 1200, 0.8)))).filter(Boolean);
      if (crop) setCropQueue(q => [...q, ...urls]);
      else setPhotos(p => [...p, ...urls].slice(0, max));
    } catch (e) { toast && toast('Could not read that image'); }
    setBusy(false);
  };
  const setMain = (i) => setPhotos(p => { const c = [...p]; const [m] = c.splice(i, 1); return [m, ...c]; });
  const remove = (i) => setPhotos(p => p.filter((_, x) => x !== i));
  const confirmCrop = (dataUrl) => {
    setPhotos(p => [...p, dataUrl].slice(0, max));
    setCropQueue(q => q.slice(1));
  };
  const cancelCrop = () => setCropQueue(q => q.slice(1));
  return (
    <div className="sess-photo-field">
      <label>{label}</label>
      <div className="upload-grid">
        {(photos || []).map((p, i) => (
          <div className={`upl-thumb ${i === 0 ? 'main' : ''}`} key={i}>
            <img src={p} alt="" />
            {i === 0 && <span className="upl-badge">Main</span>}
            <div className="upl-actions">
              {i !== 0 && <button type="button" onClick={() => setMain(i)} data-testid={`${testidPrefix}-set-main-${i}`}>Set main</button>}
              <button type="button" className="upl-x" onClick={() => remove(i)} data-testid={`${testidPrefix}-remove-${i}`}><X size={12} /></button>
            </div>
          </div>
        ))}
        {(photos || []).length < max && (
          <label className="upl-add" data-testid={`${testidPrefix}-add-btn`}>
            <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={(e) => { addFiles(e.target.files); e.target.value = ''; }} />
            <Camera size={22} />{busy ? 'Processing…' : 'Add photo'}
          </label>
        )}
      </div>
      <div className="upl-hint">{hint || `First photo is the main image, shown in the gallery first. Add up to ${max}.`}</div>
      {crop && cropQueue.length > 0 && <AvatarCrop src={cropQueue[0]} shape="square" onConfirm={confirmCrop} onCancel={cancelCrop} />}
    </div>
  );
}
